import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async create(cxt, payload) {
        let { data } = await client.post('newsLetter/users', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async createCategorie(cxt, payload) {
        let { data } = await client.post('/newsLetter/categories', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async createSousCategorie(cxt, payload) {
        let { data } = await client.post('/newsLetter/sousCategories', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
